import React from 'react';
import { MenuItem, Select, withStyles } from '@material-ui/core'; // MUI v4
import './index.css';

const styles = {
  spanPadding: {
    paddingLeft: '1rem',
  },
};

function CustomSelect({
  options = [],
  defaultValue,
  labelFor,
  onChangeHandler,
  isRequired,
  fieldName,
  labelText,
  className,
  isLoading = false,
  getTitle = (value) => value.title,
  variant = 'outlined',
  labelShow = true,
  disabled = false,
  classes,
}) {
  const handleOnChange = (e) => {
    if (typeof onChangeHandler === 'function') {
      onChangeHandler(e.target.value);
    }
  };

  return (
    <>
      {labelShow && (
        <span className="label" style={{ fontSize: '16px', fontWeight: '400' }}>
          {labelText}
          {isRequired && labelFor && <em className="requiredInput"> *</em>}
        </span>
      )}
      <Select
        value={defaultValue || ''}
        required={!!isRequired}
        id={labelFor}
        className={className ?? 'inputText'}
        variant={variant} // supported in v4
        inputProps={{ 'data-testid': 'testSelect' }}
        onChange={handleOnChange}
        disabled={disabled}
        MenuProps={{ PaperProps: { style: { maxHeight: '30rem' } } }} // No sx in v4
      >
        {isLoading && <span className={classes.spanPadding}>Loading...</span>}
        {!isLoading && (
          <MenuItem value="" disabled={isRequired}>
            {`Select ${fieldName}`}
          </MenuItem>
        )}
        {!isLoading &&
          (options || []).map((option) => (
            <MenuItem key={option.id || option} value={option.id || option}>
              {getTitle(option)}
            </MenuItem>
          ))}
      </Select>
    </>
  );
}

export default withStyles(styles)(CustomSelect);
